import S3ImageNew from "../S3ImageNew";
import { useTranslation } from "next-i18next";

const WorkerListItem = ({ workerData, line, handleClick }) => {
  const { t, i18n: { language } } = useTranslation();

  const getStatus = (log) => {
    if (log?.line_id !== line?.id && log.stop_type !== "HARD STOP") {
      return (
        <p className="mb-0" style={{ color: "#333333" }}>{`${t(
          "views.checkin.list.statusMoved"
        )} ${log?.line.number}`}</p>
      );
    }
    if (log?.stop_type === "HARD STOP") {
      return (
        <p className="mb-0" style={{ color: "#ef5350" }}>
          {t("views.checkin.list.checkout")}
        </p>
      );
    }
    if (log?.stop_type === "" && log.start_type !== "") {
      return (
        <p className="mb-0" style={{ color: "#9ba9b5" }}>
          {t("views.checkin.list.statusWorking")}
        </p>
      );
    }
  };
  const log = workerData?.worker?.timelogs[0];
  const status = getStatus(workerData.worker.timelogs[0]);
  return (
    <div
      className="d-flex flex-row"
      style={{
        borderRadius: 11,
        overflow: "auto",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.3)",
        marginTop: 8,
        cursor:'pointer'
      }}
      onClick={handleClick}
    >
      <div
        className="bg-dark d-flex justify-content-center align-items-center"
        style={{ height: 96, width: 96 }}
      >
        <S3ImageNew
          data-qa="worer-picture"
          imageKey={workerData.worker.picture}
          alt="mdo"
          width="64"
          height="64"
          layout="fixed"
          className="rounded-circle bg-white"
        />
      </div>
      <div className="bg-light" style={{ padding: "12px 8px" }}>
        <h2 className="text-primary fw-bold mb-1" style={{ fontSize: 18 }}>
          {`${workerData.worker.first_name} ${workerData.worker.last_name}`}
        </h2>
        <p className="fw-bold mb-1" style={{ minHeight: 14 }}>
          {language === "es"
            ? log?.position?.comment_es
            : log?.position?.comment || ""}
        </p>
        {status}
      </div>
    </div>
  );
};

export default WorkerListItem;
